const showEl = (e) => {
    const target = e.target.closest('.js-hover-element')
    if (target) {
        const hoverContent = target.querySelector('.js-hover-content')
        hoverContent.classList.remove('hidden')
        target.classList.add('active')
    }
}

const hideEl = (e) => {
    const target = e.target.closest('.js-hover-element')
    if (target) {
        const hoverContent = target.querySelector('.js-hover-content')
        hoverContent.classList.add('hidden')
        target.classList.remove('active')
    }
}

document.addEventListener('mouseover', showEl)
document.addEventListener('mouseout', hideEl)
